/* Industrialsafety-UK — product page (v1 1-10-2026, v2 3-10-2026): gallery, variant + quantity state, selling unit, item total,
   add to basket with inline errors, accordions, tabs, sticky bar. Pure helpers live on window.ISUPDP (unit-tested in tests/pdp.test.js). */
(function (g) {
  'use strict';
  var H = {};
  H.money = function (cents, cur) {
    var v = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur || 'GBP' }).format(v); }
    catch (e) { return '£' + v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  };
  /* whole numbers only, respecting the variant's quantity rule (min, max, increment) */
  H.clampQty = function (n, min, max, step) {
    min = Math.max(1, parseInt(min, 10) || 1);
    step = Math.max(1, parseInt(step, 10) || 1);
    max = parseInt(max, 10) || 0;
    n = parseInt(n, 10);
    if (!(n >= min)) n = min;
    n = min + Math.round((n - min) / step) * step;
    if (max && n > max) n = max - ((max - min) % step);
    return n;
  };
  H.unitText = function (mode, len) {
    switch (mode) {
      case 'metre': return 'per metre';
      case 'length': return 'per ' + len + ' length';
      case 'piece': return 'each';
      case 'none': return 'size not stated';
      default: return 'per item';
    }
  };
  H.qtyLabel = function (mode, len) {
    switch (mode) {
      case 'metre': return 'Length required (metres)';
      case 'length': return 'Number of ' + len + ' lengths';
      case 'piece': return 'Quantity (pieces)';
      default: return 'Quantity';
    }
  };
  H.whatText = function (mode, len, max, spec) {
    switch (mode) {
      case 'metre': return 'Quantity 1 = 1 metre.' + (max ? ' Up to ' + max + ' m comes as one piece; longer totals are supplied in pieces of up to ' + max + ' m.' : '');
      case 'length': return 'Quantity 1 = one ' + len + ' length' + (spec ? ' of ' + spec : '') + '.';
      case 'piece': return 'Quantity 1 = one piece.';
      case 'none': return 'This listing has no size data, so it can’t be ordered online. Choose a stocked size below or request a quote.';
      default: return 'Quantity 1 = one item as listed. The supplied length isn’t stated — ask us before ordering if it matters.';
    }
  };
  H.total = function (n, cents) { return (parseInt(n, 10) || 0) * (Number(cents) || 0); };
  H.totalNote = function (n, cents, cur, mode, len, kgPerM) {
    var s = n + ' × ' + H.money(cents, cur) + ' ' + H.unitText(mode, len);
    if (mode === 'metre' && kgPerM > 0) s += ' · ≈ ' + (Math.round(kgPerM * n * 100) / 100).toFixed(2) + ' kg';
    return s;
  };
  g.ISUPDP = H;
})(typeof window !== 'undefined' ? window : globalThis);

(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  var root = document.querySelector('[data-isu-pdp]');
  if (!root) return;
  var H = window.ISUPDP;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var setText = function (sel, txt) { $$(sel).forEach(function (e) { e.textContent = txt; }); };

  /* ---------- gallery ---------- */
  var slides = $$('.isu-gal__slide'), thumbs = $$('[data-show]');
  var show = function (b) {
    var k = b.getAttribute('data-show');
    slides.forEach(function (s) {
      var on = s.getAttribute('data-slide') === k;
      s.classList.toggle('is-on', on);
      if (on) { var im = s.querySelector('img'); if (im) im.loading = 'eager'; }
    });
    thumbs.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  };
  thumbs.forEach(function (b, i) {
    b.addEventListener('click', function () { show(b); });
    b.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var n = thumbs[(i + (e.key === 'ArrowRight' ? 1 : thumbs.length - 1)) % thumbs.length];
      n.focus(); show(n);
    });
  });

  /* ---------- state ---------- */
  var form = $('#isu-pf'), idIn = $('[data-isu-id]'), qty = $('[data-isu-qty]');
  var add = $('[data-isu-add]'), now = $('[data-isu-now]'), ret = $('[data-isu-return]'), msg = $('[data-isu-msg]');
  var mode = root.getAttribute('data-unit-mode') || 'unknown';
  var cur = root.getAttribute('data-currency') || 'GBP';
  var spec = root.getAttribute('data-specline') || '';
  var maxcut = root.getAttribute('data-max') || '';
  var kg = parseFloat(root.getAttribute('data-weight')) || 0;
  var vbtns = $$('[data-isu-variant]');
  var on0 = vbtns.filter(function (b) { return b.classList.contains('is-on'); })[0];
  var priceEl = $('[data-isu-price]');
  var st = {
    id: idIn ? idIn.value : '',
    cents: on0 ? Number(on0.getAttribute('data-cents')) : Math.round(parseFloat(((priceEl && priceEl.textContent) || '0').replace(/[^0-9.]/g, '')) * 100),
    available: add ? !add.disabled : false,
    len: on0 ? on0.getAttribute('data-len') : '',
    min: qty ? qty.min : 1, max: qty ? qty.max : '', step: qty ? qty.step : 1,
    title: on0 ? on0.getAttribute('data-title') : '',
    sku: on0 ? on0.getAttribute('data-sku') : ''
  };
  if (!st.len) { var vl = $('[data-isu-vlen]'); if (vl && !vl.hidden) st.len = vl.textContent.replace(/ length$/, ''); }
  var n = function () { return qty ? H.clampQty(qty.value, st.min, st.max, st.step) : 1; };

  var render = function () {
    var q = n();
    if (qty && String(q) !== qty.value) qty.value = q;
    var unit = H.unitText(mode, st.len);
    setText('[data-isu-price]', H.money(st.cents, cur));
    setText('[data-isu-unit]', unit);
    setText('[data-isu-what]', H.whatText(mode, st.len, maxcut, spec));
    setText('[data-isu-qlabel]', H.qtyLabel(mode, st.len));
    setText('[data-isu-total]', H.money(H.total(q, st.cents), cur));
    setText('[data-isu-totalnote]', H.totalNote(q, st.cents, cur, mode, st.len, kg));
    setText('[data-isu-sprice]', H.money(st.cents, cur));
    setText('[data-isu-sunit]', unit);
    setText('[data-isu-sqty]', q);
    $$('[data-isu-set]').forEach(function (c) { c.classList.toggle('is-on', parseInt(c.getAttribute('data-isu-set'), 10) === q); });
    if (mode === 'length' && st.len) {
      $$('[data-isu-vlen]').forEach(function (e) { e.hidden = false; e.textContent = st.len + ' length'; });
      setText('[data-isu-speclen]', st.len);
    }
    if (st.sku) setText('[data-isu-sku]', st.sku);
    setText('[data-isu-avail]', st.available ? 'Available to order' : 'Currently unavailable');
    if (add) { add.disabled = !st.available; var al = $('[data-isu-addlabel]'); if (al) al.textContent = st.available ? 'Add to basket' : 'Sold out'; }
    if (now) now.hidden = !st.available;
    var sb = $('[data-isu-stickyadd]');
    if (sb) { sb.disabled = !st.available; sb.textContent = st.available ? 'Add to basket' : 'Sold out'; }
    root.isuState = { qty: q, title: st.title, sku: st.sku, price: H.money(st.cents, cur), unit: unit, mode: mode };
    root.dispatchEvent(new CustomEvent('isu:state', { bubbles: true, detail: root.isuState }));
  };

  if (qty) {
    qty.addEventListener('change', render);
    qty.addEventListener('input', function () { if (qty.value !== '') render(); });
    $$('[data-isu-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = parseInt(st.step, 10) || 1;
        qty.value = H.clampQty((parseInt(qty.value, 10) || 0) + parseInt(b.getAttribute('data-isu-step'), 10) * s, st.min, st.max, st.step);
        render();
      });
    });
    $$('[data-isu-set]').forEach(function (c) { c.addEventListener('click', function () { qty.value = c.getAttribute('data-isu-set'); render(); }); });
  }

  vbtns.forEach(function (b) {
    b.addEventListener('click', function () {
      vbtns.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      st.id = b.getAttribute('data-isu-variant'); idIn.value = st.id;
      st.cents = Number(b.getAttribute('data-cents'));
      st.available = b.getAttribute('data-available') === 'true';
      st.len = b.getAttribute('data-len') || st.len;
      st.min = b.getAttribute('data-min') || 1; st.max = b.getAttribute('data-max') || ''; st.step = b.getAttribute('data-step') || 1;
      st.title = b.getAttribute('data-title'); st.sku = b.getAttribute('data-sku');
      if (qty) { qty.min = st.min; if (st.max) qty.max = st.max; else qty.removeAttribute('max'); qty.step = st.step; }
      if (msg) msg.hidden = true;
      try { var u = new URL(location.href); u.searchParams.set('variant', st.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      render();
    });
  });

  /* ---------- add to basket (inline errors) / buy it now ---------- */
  if (form) {
    var lastBtn = null;
    [add, now].forEach(function (b) { if (b) b.addEventListener('click', function () { lastBtn = b; }); });
    form.addEventListener('submit', function (e) {
      var sub = e.submitter || lastBtn;
      if (qty) qty.value = n();
      if (sub && sub === now) { if (ret) ret.disabled = false; return; }
      if (ret) ret.disabled = true;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (add) { add.disabled = true; add.setAttribute('aria-busy', 'true'); }
      var action = (form.getAttribute('action') || '/cart/add').split('?')[0];
      fetch(action + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok) { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart'; return; }
          if (msg) { msg.hidden = false; msg.textContent = (res.j && (res.j.description || res.j.message)) || 'Sorry, this item could not be added to your basket. Please try again or call us.'; }
          if (add) { add.disabled = !st.available; add.removeAttribute('aria-busy'); }
        })
        .catch(function () { if (add) add.removeAttribute('aria-busy'); form.submit(); });
    });
  }

  /* ---------- accordions: open on desktop, collapsible on mobile ---------- */
  var mq = window.matchMedia('(min-width: 750px)');
  var accs = $$('[data-isu-acc]');
  var setAcc = function () { if (mq.matches) accs.forEach(function (d) { d.open = true; }); };
  setAcc();
  if (mq.addEventListener) mq.addEventListener('change', setAcc);
  accs.forEach(function (d) {
    var s = d.querySelector(':scope > summary');
    if (s) s.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
  });
  /* in-page links open their (mobile) accordion first */
  $$('a[href^="#isu-"]').forEach(function (a) {
    a.addEventListener('click', function () {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t && t.tagName === 'DETAILS') t.open = true;
    });
  });

  /* reviews: show all */
  var more = $('[data-isu-more]');
  if (more) more.addEventListener('click', function () {
    $$('[data-isu-revs] li').forEach(function (li) { li.hidden = false; li.classList.add('is-open'); });
    more.remove();
  });

  /* in-page tab highlight */
  var links = $$('.isu-tabs a[href^="#isu-"]');
  if ('IntersectionObserver' in window && links.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id); });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t && t.tagName !== 'DIALOG') io.observe(t); });
  }

  /* ---------- sticky bar (mobile): after the buy buttons scroll away, hidden over the footer ---------- */
  var bar = $('[data-isu-sticky]');
  var anchor = add || $('.isu-acts2') || $('.isu-pricebox');
  if (bar && anchor) {
    var foot = document.querySelector('footer, .site-footer, [class*="footer__section"]');
    var tick = false;
    var check = function () {
      tick = false;
      var past = anchor.getBoundingClientRect().bottom < 0;
      var footIn = foot ? foot.getBoundingClientRect().top < window.innerHeight - 10 : false;
      var dlg = document.getElementById('isu-quote');
      bar.hidden = !past || footIn || !!(dlg && dlg.open);
      document.documentElement.classList.toggle('isu-sticky-on', !bar.hidden);
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    document.addEventListener('isu:dialog', check);
    check();
    var sb = $('[data-isu-stickyadd]', bar);
    if (sb && add) sb.addEventListener('click', function () { lastBtn = add; if (form.requestSubmit) form.requestSubmit(add); else add.click(); });
    var ss = $('[data-isu-stickysizes]', bar);
    if (ss) ss.addEventListener('click', function (e) {
      var fs = document.getElementById('isu-sizes-fs'); if (!fs) return;
      e.preventDefault(); fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = fs.querySelector('a, button'); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
    });
  }

  if (qty) render();
})();

/* sort size buttons by their numbers (25.4 × 4.8 …), then by finish */
(function () {
  if (typeof document === 'undefined') return;
  var box = document.querySelector('[data-isu-sizes]');
  if (!box) return;
  var nums = function (el) { var b = el.querySelector('b'); return ((b && b.textContent) || '').split('×').map(function (x) { return parseFloat(x) || 0; }); };
  var fin = function (el) { var s = el.querySelector('small'); return (s && s.textContent) || ''; };
  var items = Array.prototype.slice.call(box.children);
  items.sort(function (a, b) { var x = nums(a), y = nums(b); for (var i = 0; i < Math.max(x.length, y.length); i++) { var d = (x[i] || 0) - (y[i] || 0); if (d) return d; } return fin(a) < fin(b) ? -1 : fin(a) > fin(b) ? 1 : 0; });
  items.forEach(function (el) { box.appendChild(el); });
  var on = box.querySelector('.is-on'); if (on && box.scrollWidth > box.clientWidth) box.scrollLeft = on.offsetLeft - 16;
})();

/* finish filter for the stocked-size list (unsized listings) */
(function () {
  if (typeof document === 'undefined') return;
  var f = document.querySelector('[data-isu-finf]'), box = document.querySelector('[data-isu-sizes]');
  if (!f || !box) return;
  var items = Array.prototype.slice.call(box.querySelectorAll('[data-fin]'));
  var fins = [];
  items.forEach(function (a) { var v = a.getAttribute('data-fin'); if (v && fins.indexOf(v) < 0) fins.push(v); });
  if (fins.length < 2) return;
  fins.sort();
  var make = function (label, val) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'isu-chip'; b.textContent = label; b.setAttribute('aria-pressed', val === '' ? 'true' : 'false');
    b.addEventListener('click', function () {
      Array.prototype.forEach.call(f.children, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); x.classList.toggle('is-on', x === b); });
      items.forEach(function (a) { a.hidden = !!val && a.getAttribute('data-fin') !== val; });
    });
    if (val === '') b.classList.add('is-on');
    f.appendChild(b);
  };
  make('All finishes', '');
  fins.forEach(function (v) { make(v, v); });
  f.hidden = false;
})();
